
export const PublicSellerCertificatesQuery = new TypedDocumentString(`
    query PublicSellerCertificatesQuery($sellerId: ObjectId!) {
  publicSellerCertificates(sellerId: $sellerId) {
    ...ProductCertificate
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment ProductCertificate on ProductCertificate {
  title {
    value
    __typename
  }
  description {
    value
    __typename
  }
  image {
    ...Image
    __typename
  }
  __typename
}`, {"hash":"4b9721cb9bdb4870933d02ef84e4fc69d220977adb8fa7d0591e84f32dc83400"});